export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  DEACTIVATED: "DEACTIVATED",
  SUSPENDED: "SUSPENDED"
};
